import ApplicationController from './application_controller'

export default class extends ApplicationController {
    reflexSuccess (element, reflex, noop, reflexId) {
        this.reload_tippies();
    }
}